// removed by extract-text-webpack-plugin
module.exports = {"container":"_3u8b2NX1SJV0wyQq8wfn1B","create":"_2og296AMvTaNzdw62C12Yd","button":"_7tQnb2OmizG6Z-XACkWXM"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/CreateDocument/styles.css
// module id = 3251
// module chunks = 0